import React from 'react';
import { useController } from 'react-hook-form';
import { Form, Input } from '@weezevent/nacre';
import { FieldErrorMessage } from '../FieldErrorMessage';
import PropTypes from 'prop-types';

export const FormInput = ({ name, label, disabled = false, required = false, ...rest }) => {
    const {
        field: { value, onChange },
        fieldState: { error }
    } = useController({
        name
    });

    return (
        <Form.Field>
            <Form.Label for={name} label={label} required={required} />
            <Input
                errors={!!error}
                id={name}
                value={value}
                onChange={({ target: { value } }) => {
                    onChange(value);
                }}
                disabled={disabled}
                {...rest}
            />
            <FieldErrorMessage error={error} />
        </Form.Field>
    );
};

FormInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    required: PropTypes.bool
};
